import React from 'react';
import './Tour.css';

function Tour() {
  return (
    <div className="main tour">
      <div className="tour__container">
        <div className="tour__header hidden-xs">
          <ul class="tour__title__row">
            <li>Date &amp; Time </li>
            <li>Venue &amp; Location </li>
            <li>Tour Details </li>
            <li>Tickets </li>
            <li>Share </li>
          </ul>
        </div>
        <div className="tour__dates">
          {/* HERE IS WHERE EVENTS MAKEUP WILL GO AND THERE IS SOME START UP STYLE IN TOUR.CSS */}
          <p className="tour__no__results">No events</p>
        </div>
      </div>
    </div>
  );
}

export default Tour;
